export default "__VITE_PUBLIC_ASSET__26a5e607__"